import Vue from 'vue'
import Router from 'vue-router'
import { isMobile } from '@/common/utils/device.js'

// 电脑端组件
import LoginPC from '@/views/Login.vue'
import IndexPC from '@/views/index.vue'

// 手机端组件（需创建）
import LoginMobile from '@/views/LoginMobile.vue'
import IndexMobile from '@/views/IndexMobile.vue'
import SortDetailMobile from '@/views/SortDetailMobile.vue'


Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    // 电脑端路由
    {
      path: '/login-pc',
      name: 'LoginPC',
      component: LoginPC,
    },
    {
      path: '/index-pc',
      name: 'IndexPC',
      component: IndexPC,
      children: [
      ]
    },

    // 手机端路由
    // {
    //   path: '/login-mobile',
    //   name: 'LoginMobile',
    //   component: LoginMobile,
    // },
    // {
    //   path: '/index-mobile',
    //   name: 'IndexMobile',
    //   component: IndexMobile,
    //   children: [
    //   ]
    // },
    // {
    //   path: '/SortDetailMobile',
    //   name: 'SortDetailMobile',
    //   component: SortDetailMobile,
    //   children: [
    //   ]
    // },

    // 根路径自动分流
    {
      path: '/',
      redirect: () => '/login-PC' 
    }
  ]
})

// 全局路由守卫（防止跨设备访问）
// router.beforeEach((to, from, next) => {
//   const isMobileDevice = isMobile();
//   const userInfo = localStorage.getItem('userinfo') ? JSON.parse(localStorage.getItem('userinfo')) : null;
//   const hasToken = userInfo && userInfo.token;

//   // 手机访问电脑路由
//   if (isMobileDevice && to.path.includes('-pc')) {
//     next(hasToken ? '/index-mobile' : '/login-mobile');
//     return;
//   }

//   // 电脑访问手机路由
//   if (!isMobileDevice && to.path.includes('-mobile')) {
//     next(hasToken ? '/index-pc' : '/login-pc');
//     return;
//   }

//   // 登录校验
//   const needLogin = to.path.includes('index-');
//   if (needLogin && !hasToken) {
//     next(isMobileDevice ? '/login-mobile' : '/login-pc');
//   } else {
//     next();
//   }
// })

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js